// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageViewerContainer {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  width: 100%;
}

.imageViewerContainer .imageContainer {
  position: relative;
  width: 100%;
  padding-top: 100%; /* Keeps the 1:1 aspect ratio */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0; /* Light background color visible during loading */
}

.imageViewerContainer .imageWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.imageViewerContainer .uploadedByCard {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 8px 10px;
  font-size: 14px;
  color: #171717;
  text-align: center;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background-color 0.2s ease;
}

.imageViewerContainer .loadingStyle {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  font-size: 1rem;
  z-index: 1; /* Ensures it's above the container background but below images */
}

.imageViewerContainer .imageContainer img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2; /* Ensures image is above the loading message */
  display: none; /* Initially hide images */
}

/* Center videos in the listing screens */
.imageViewerContainer .imageContainer video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 2;
  display: block;
  max-width: 100%;
  max-height: 100%;
}

/* Ensure VideoViewer component is properly sized in grid */
.imageViewerContainer .imageContainer > div {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
}

/* Style for selection checkboxes */
.imageViewerContainer .imageContainer [data-testid="pressable"] {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  left: auto !important;
  z-index: 10 !important;
}

/* Override any conflicting positioning for checkboxes */
.imageViewerContainer .imageContainer > div > div[style*="position: absolute"] {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  left: auto !important;
  bottom: auto !important;
  z-index: 10 !important;
}

@media (min-width: 768px) {
  .imageViewerContainer {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}

@media (min-width: 1024px) {
  .imageViewerContainer {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/imageViewer/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB,EAAE,kDAAkD;AAC/E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU,EAAE,iEAAiE;AAC/E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU,EAAE,+CAA+C;EAC3D,aAAa,EAAE,0BAA0B;AAC3C;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF","sourcesContent":[".imageViewerContainer {\n  display: grid;\n  gap: 4px;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  width: 100%;\n}\n\n.imageViewerContainer .imageContainer {\n  position: relative;\n  width: 100%;\n  padding-top: 100%; /* Keeps the 1:1 aspect ratio */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f0f0f0; /* Light background color visible during loading */\n}\n\n.imageViewerContainer .imageWrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.imageViewerContainer .uploadedByCard {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 8px 10px;\n  font-size: 14px;\n  color: #171717;\n  text-align: center;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background-color 0.2s ease;\n}\n\n.imageViewerContainer .loadingStyle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: black;\n  font-size: 1rem;\n  z-index: 1; /* Ensures it's above the container background but below images */\n}\n\n.imageViewerContainer .imageContainer img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 2; /* Ensures image is above the loading message */\n  display: none; /* Initially hide images */\n}\n\n/* Center videos in the listing screens */\n.imageViewerContainer .imageContainer video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  z-index: 2;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n/* Ensure VideoViewer component is properly sized in grid */\n.imageViewerContainer .imageContainer > div {\n  position: absolute !important;\n  top: 0 !important;\n  right: 0 !important;\n}\n\n/* Style for selection checkboxes */\n.imageViewerContainer .imageContainer [data-testid=\"pressable\"] {\n  position: absolute !important;\n  top: 8px !important;\n  right: 8px !important;\n  left: auto !important;\n  z-index: 10 !important;\n}\n\n/* Override any conflicting positioning for checkboxes */\n.imageViewerContainer .imageContainer > div > div[style*=\"position: absolute\"] {\n  position: absolute !important;\n  top: 8px !important;\n  right: 8px !important;\n  left: auto !important;\n  bottom: auto !important;\n  z-index: 10 !important;\n}\n\n@media (min-width: 768px) {\n  .imageViewerContainer {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .imageViewerContainer {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
